import React, { SetStateAction, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AuthSocialPlatformCard } from '../../../../../authentication/social/components/AuthSocialPlatformCard';
import { ManualAuthorisationModal } from '../../../../../authentication/social/modal/ManualAuthorisation';
import { Platforms } from '../../../../../model/platform/Platforms';
import { IAllStates } from '../../../../../store/rootReducer';
import { ErrorToast } from '../../../../../utils/toasters';
import { InfluencerService } from '../../../service';
import AlertBox from '../../../../../shared/components/alert/AlertBox';

interface IProfileSocialProps {
    platforms: Platforms[];
    setUpdatePlatforms: React.Dispatch<SetStateAction<boolean>>;
}

const ProfileSocial = ({ platforms, setUpdatePlatforms }: IProfileSocialProps) => {
    const { t } = useTranslation();
    const [isAuthorisationOpened, setIsAuthorisationOpened] = useState(false);
    const [platform, setPlatform] = useState<Platforms>();
    const [enabledPlatformData, setEnabledPlatformData] = useState<Platforms | undefined>(undefined);
    const id = useSelector((state: IAllStates) => state.auth.user.id);
    const selectedInfluencerId = localStorage.getItem('selectedAgencyCreator');

    const closeModal = () => {
        setIsAuthorisationOpened(false);
        setUpdatePlatforms(prev => !prev);
    };
    const openModal = (selectedPlatform?: Platforms) => {
        setIsAuthorisationOpened(true);
        setPlatform(selectedPlatform);
        InfluencerService.getPlatformData(Number(selectedPlatform?.id))
            .then(response => {
                setEnabledPlatformData(response);
            })
            .catch(error => ErrorToast(error));
    };

    return (
        <div className="mb-4">
            <ManualAuthorisationModal
                show={isAuthorisationOpened}
                closeModal={closeModal}
                enabledPlatformData={enabledPlatformData}
                platform={platform}
                id={selectedInfluencerId ? +selectedInfluencerId : id}
            />
            <h6>{t('influencer.profile.socialAccounts')}</h6>
            <p className="text-muted mb-2">{t('influencer.profile.socialAccountsDescription')}</p>
            <AlertBox
                image="/icons/img-warning.svg"
                desc={t('influencer.profile.socialDataInfoAlert')}
                classCol={'w-fit-content'}
                title=""
            />
            <Row>
                {platforms?.map(item => (
                    <Col key={item?.id} md={6} lg={4} className="mt-3">
                        <AuthSocialPlatformCard
                            setUpdatePlatforms={setUpdatePlatforms}
                            openManualAuthModal={openModal}
                            platform={item}
                        />
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default ProfileSocial;
